var map = {
	"./bookmark.svg": 2803,
	"./category-root.svg": 9732,
	"./check.svg": 8677,
	"./close.svg": 1825,
	"./cta-run.svg": 323,
	"./cta-tutorials.svg": 7293,
	"./discount.svg": 74,
	"./feat-annotate.svg": 8076,
	"./feat-blur.svg": 1975,
	"./feat-button.svg": 9888,
	"./feat-copy-paste.svg": 6509,
	"./feat-crop.svg": 8694,
	"./feat-cursors.svg": 4317,
	"./feat-export.svg": 7086,
	"./feat-focus.svg": 9004,
	"./feat-import.svg": 883,
	"./feat-intro.svg": 3490,
	"./feat-record.svg": 3851,
	"./feat-rewrite.svg": 4796,
	"./feat-share.svg": 1613,
	"./feat-templates.svg": 309,
	"./feat-text-to-audio.svg": 8768,
	"./feat-toc.svg": 9894,
	"./feat-touch.svg": 8857,
	"./feat-translate.svg": 9030,
	"./feat-type.svg": 7964,
	"./feat-zoom.svg": 4309,
	"./features.svg": 1414,
	"./film.svg": 6233,
	"./flag-canada.svg": 8032,
	"./flag-eu.svg": 2700,
	"./logo.svg": 5318,
	"./menu.svg": 3782,
	"./minus.svg": 4189,
	"./play.svg": 5825,
	"./plus.svg": 5007,
	"./pricing.svg": 3991,
	"./samples.svg": 2684,
	"./star.svg": 8027,
	"./tutorials.svg": 468,
	"./view.svg": 6200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5848;